import CompanyTableHelper from './company-table-helper';


const CompanyHelpers = {
    TableMain: CompanyTableHelper,
}

export default CompanyHelpers;